define("shared/utils/formatters/ig-reel-from-dynamo", ["exports", "later/models/ig-reel"], function (_exports, _igReel) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-reel"eaimeta@70e063a35619d71f
  /* eslint-disable prefer-destructuring */
  /**
   * Converts a raw dynamo post into a DynamoIgReel
   *
   */
  function createIgReelFromDynamo(obj, socialProfile) {
    const engagements = calculateEngagements(obj);
    return new _igReel.default({
      socialProfile,
      id: obj.id,
      createdTime: obj.created_time,
      type: obj.type,
      isDeleted: obj.is_deleted,
      thumbUrl: obj.permanent_image_url || obj.image_square_url,
      imageUrl: obj.permanent_image_url || obj.image_medium_url || obj.image_square_url,
      engagement: obj.engagement_rate ? Number(obj.engagement_rate) : undefined,
      engagements: engagements ? Number(engagements) : undefined,
      reach: (obj.carousel_album_reach || obj.reach) ?? undefined,
      savedCount: (obj.carousel_album_saved || obj.saved) ?? undefined,
      plays: obj.plays ?? undefined,
      totalPlays: obj.total_plays ?? undefined,
      views: obj.views ?? undefined,
      shareCount: obj.shares ?? undefined,
      commentCount: obj.comment_count ?? undefined,
      likeCount: obj.like_count ?? undefined,
      standardResUrl: obj.image_medium_url,
      instagramLink: obj.link,
      caption: obj.caption,
      mediaProductType: obj.media_product_type,
      scheduledPost: obj.scheduledPost ?? undefined
    });
  }
  function calculateEngagements(obj) {
    const likes = obj.like_count;
    const comments = obj.comment_count;
    const shares = obj.shares;
    const saves = obj.saved;
    if (!likes && !comments && !shares && !saves) {
      return undefined;
    }
    return (likes ?? 0) + (comments ?? 0) + (shares ?? 0) + (saves ?? 0);
  }
  var _default = _exports.default = createIgReelFromDynamo;
});